import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import PasswordModuleTypes from '@/store/modules/middleGround/my/password/interface';

const passwordModule: Module<PasswordModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {
        aesKey: '',
    },
    mutations: {
        aesKey(state, aesKey) {
            state.aesKey = aesKey;
        },
    },
    actions: {
        getAesKey(context) {
            tool.get("/login/getAesKey", {}).then(value => {
                context.commit('aesKey', value.result);
            });
        },
        updatePassword(context, params) {
            var oldPassword = tool.md5Encrypt(params.oldPassword);
            oldPassword = tool.aesEncrypt(context.state.aesKey.trim(), oldPassword);
            var password = tool.md5Encrypt(params.password);
            password = tool.aesEncrypt(context.state.aesKey.trim(), password);
            var paramMaps = {
                oldPassword: oldPassword,
                newPassword: password,
            };
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/changePasswd", paramMaps).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
    },
};

export default passwordModule;